import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import axios from 'axios';

const API = 'https://app.b3rastreamento.com.br/api';

const tiposAlerta = {
  ignicao_ligada: { label: '🔑 Ignição Ligada', cor: '#1D9E75' },
  ignicao_desligada: { label: '🔒 Ignição Desligada', cor: '#F59E0B' },
  velocidade: { label: '🚨 Velocidade', cor: '#E24B4A' },
  cerca_virtual: { label: '📍 Cerca Virtual', cor: '#378ADD' },
  sem_sinal: { label: '📵 Sem Sinal', cor: '#666' },
  bateria_desconectada: { label: '🔋 Corte de Energia', cor: '#A32D2D' },
};

function BarraHorizontal({ valor, maximo, cor }) {
  const pct = maximo > 0 ? (valor / maximo) * 100 : 0;
  return (
    <div style={{ background: '#f0f0f0', borderRadius: '4px', height: '8px', flex: 1 }}>
      <div style={{ background: cor, borderRadius: '4px', height: '8px', width: `${pct}%`, transition: 'width .5s' }} />
    </div>
  );
}

function formatarTempo(horas) {
  if (!horas) return 'Nunca conectou';
  if (horas < 1) return 'Menos de 1h';
  if (horas < 24) return `${Math.floor(horas)}h atrás`;
  const dias = Math.floor(horas / 24);
  return `${dias} dia${dias > 1 ? 's' : ''} atrás`;
}

function exportarPDF(titulo, dados) {
  const conteudo = `
    <html>
    <head>
      <meta charset="utf-8">
      <title>${titulo}</title>
      <style>
        body { font-family: Arial, sans-serif; font-size: 12px; color: #333; padding: 20px; }
        h1 { color: #1D9E75; font-size: 18px; margin-bottom: 4px; }
        p { color: #999; font-size: 11px; margin-bottom: 20px; }
        table { width: 100%; border-collapse: collapse; }
        th { background: #1D9E75; color: white; padding: 8px 10px; text-align: left; font-size: 11px; }
        td { padding: 8px 10px; border-bottom: 1px solid #eee; font-size: 11px; }
        tr:nth-child(even) td { background: #f9f9f9; }
        .footer { margin-top: 20px; text-align: center; color: #999; font-size: 10px; }
      </style>
    </head>
    <body>
      <h1>${titulo}</h1>
      <p>Gerado em ${new Date().toLocaleString('pt-BR')} — Desenvolvido por Digital Mais BR</p>
      <table>
        <thead>
          <tr>
            <th>Placa</th>
            <th>Nome</th>
            <th>Cliente</th>
            <th>Telefone</th>
            <th>Modelo Equip.</th>
            <th>Chip</th>
            <th>Última Atualização</th>
            <th>Tempo Offline</th>
          </tr>
        </thead>
        <tbody>
          ${dados.map(v => `
            <tr>
              <td>${v.identificador || '—'}</td>
              <td>${v.nome || '—'}</td>
              <td>${v.cliente_nome || '—'}</td>
              <td>${v.cliente_celular || v.cliente_telefone || '—'}</td>
              <td>${v.equipamento_modelo || '—'}</td>
              <td>${v.numero_chip || '—'}</td>
              <td>${v.ultima_atualizacao ? new Date(v.ultima_atualizacao).toLocaleString('pt-BR') : 'Nunca'}</td>
              <td>${formatarTempo(v.horas_sem_sinal)}</td>
            </tr>
          `).join('')}
        </tbody>
      </table>
      <div class="footer">Desenvolvido por Digital Mais BR — digitalmaisbr.com.br</div>
    </body>
    </html>
  `;
  const janela = window.open('', '_blank');
  janela.document.write(conteudo);
  janela.document.close();
  janela.focus();
  setTimeout(() => janela.print(), 500);
}

function Estatisticas() {
  const [sidebarAberta, setSidebarAberta] = useState(false);
  const [dados, setDados] = useState(null);
  const [carregando, setCarregando] = useState(true);
  const [faixaSelecionada, setFaixaSelecionada] = useState(null);
  const [modalInventario, setModalInventario] = useState(null); // { tipo: 'modelo'|'operadora', item }
  const usuario = JSON.parse(localStorage.getItem('usuario') || '{}');

  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => { carregarDados(); }, []);

  const carregarDados = async () => {
    setCarregando(true);
    try {
      const res = await axios.get(`${API}/estatisticas`, { headers });
      setDados(res.data);
    } catch (err) { console.error(err); }
    setCarregando(false);
  };

  if (carregando) {
    return (
      <div style={{ minHeight: '100vh', background: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ textAlign: 'center', color: '#666' }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>📊</div>
          <div style={{ fontSize: '16px' }}>Carregando estatísticas...</div>
        </div>
      </div>
    );
  }

  const r = dados?.resumo || {};
  const maxVeiculo = Math.max(...(dados?.veiculos_mais_ativos || []).map(v => parseInt(v.total_posicoes)), 1);
  const maxAlerta = Math.max(...(dados?.alertas_por_tipo || []).map(a => parseInt(a.total)), 1);
  const maxDia = Math.max(...(dados?.posicoes_por_dia || []).map(p => parseInt(p.total)), 1);

  const faixas = [
    { key: 'h6', label: '+6h', cor: '#666', bg: '#f0f0f0', corTexto: '#444' },
    { key: 'h24', label: '+24h', cor: '#F59E0B', bg: '#FAEEDA', corTexto: '#633806' },
    { key: 'h48', label: '+48h', cor: '#E87B1E', bg: '#FDE8D0', corTexto: '#7A3800' },
    { key: 'h72', label: '+72h', cor: '#E24B4A', bg: '#FCEBEB', corTexto: '#A32D2D' },
  ];

  const desconectadosFaixa = faixaSelecionada ? (dados?.desconectados?.[faixaSelecionada] || []) : [];
  const faixaInfo = faixas.find(f => f.key === faixaSelecionada);

  // Classifica acessos por período
  const agora = new Date();
  const acessosHoje = (dados?.ultimos_acessos || []).filter(u => {
    if (!u.ultimo_acesso) return false;
    const d = new Date(u.ultimo_acesso);
    return (agora - d) < 24 * 3600 * 1000;
  });
  const acessosOntem = (dados?.ultimos_acessos || []).filter(u => {
    if (!u.ultimo_acesso) return false;
    const d = new Date(u.ultimo_acesso);
    const diff = (agora - d) / 3600 / 1000;
    return diff >= 24 && diff < 48;
  });
  const acessosSemana = (dados?.ultimos_acessos || []).filter(u => {
    if (!u.ultimo_acesso) return false;
    const d = new Date(u.ultimo_acesso);
    const diff = (agora - d) / 3600 / 1000;
    return diff >= 48 && diff < 168;
  });
  const semAcesso = (dados?.ultimos_acessos || []).filter(u => !u.ultimo_acesso);

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5' }}>
      <Sidebar aberta={sidebarAberta} setAberta={setSidebarAberta} />

      <div style={{ background: '#1D9E75', padding: '0 24px', height: '60px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'fixed', top: 0, left: 0, right: 0, zIndex: 500, boxShadow: '0 2px 10px rgba(0,0,0,0.2)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <button onClick={() => setSidebarAberta(!sidebarAberta)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '22px', color: 'white' }}>{sidebarAberta ? '✕' : '☰'}</button>
          <span style={{ color: 'white', fontWeight: '700', fontSize: '18px' }}>📈 Estatísticas</span>
        </div>
        <button onClick={carregarDados} style={{ background: 'rgba(255,255,255,0.2)', color: 'white', border: '1px solid rgba(255,255,255,0.4)', borderRadius: '8px', padding: '8px 16px', cursor: 'pointer', fontWeight: '600', fontSize: '14px' }}>
          🔄 Atualizar
        </button>
      </div>

      <div style={{ marginTop: '60px', padding: '24px' }}>

        {/* LINHA 1 — Cards resumo */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px', marginBottom: '24px' }}>
          {[
            { label: 'Total Veículos', valor: r.total_targets || 0, sub: `${r.targets_ativos || 0} online agora`, cor: '#1D9E75', icon: '🚗' },
            { label: 'Total Clientes', valor: r.total_clientes || 0, sub: `${r.clientes_ativos || 0} ativos`, cor: '#378ADD', icon: '👥' },
            { label: 'Posições Registradas', valor: (r.total_posicoes || 0).toLocaleString('pt-BR'), sub: 'total histórico', cor: '#7C3AED', icon: '📍' },
            { label: 'Alertas Hoje', valor: r.alertas_hoje || 0, sub: 'últimas 24h', cor: '#E24B4A', icon: '🔔' },
          ].map((c, i) => (
            <div key={i} style={{ background: 'white', borderRadius: '12px', padding: '20px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)', borderLeft: `4px solid ${c.cor}` }}>
              <div style={{ fontSize: '28px', marginBottom: '8px' }}>{c.icon}</div>
              <div style={{ fontSize: '26px', fontWeight: '700', color: c.cor }}>{c.valor}</div>
              <div style={{ fontSize: '13px', color: '#333', fontWeight: '500', marginTop: '2px' }}>{c.label}</div>
              <div style={{ fontSize: '11px', color: '#999', marginTop: '2px' }}>{c.sub}</div>
            </div>
          ))}
        </div>

        {/* LINHA 2 — Veículos desconectados */}
        <div style={{ background: 'white', borderRadius: '12px', padding: '20px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)', marginBottom: '16px' }}>
          <h3 style={{ margin: '0 0 16px', fontSize: '14px', color: '#333' }}>📡 Veículos Sem Sinal — Clique para ver a lista</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '12px', marginBottom: faixaSelecionada ? '20px' : '0' }}>
            {faixas.map(f => {
              const qtd = dados?.desconectados?.[f.key]?.length || 0;
              const ativo = faixaSelecionada === f.key;
              return (
                <div key={f.key} onClick={() => setFaixaSelecionada(ativo ? null : f.key)}
                  style={{ background: ativo ? f.cor : f.bg, borderRadius: '10px', padding: '16px', cursor: 'pointer', border: `2px solid ${ativo ? f.cor : 'transparent'}`, transition: 'all .15s', textAlign: 'center' }}>
                  <div style={{ fontSize: '28px', fontWeight: '700', color: ativo ? 'white' : f.cor }}>{qtd}</div>
                  <div style={{ fontSize: '13px', fontWeight: '600', color: ativo ? 'white' : f.corTexto, marginTop: '4px' }}>Offline {f.label}</div>
                  <div style={{ fontSize: '11px', color: ativo ? 'rgba(255,255,255,0.8)' : '#999', marginTop: '2px' }}>
                    {qtd === 0 ? 'Nenhum' : `${qtd} veículo${qtd > 1 ? 's' : ''}`}
                  </div>
                </div>
              );
            })}
          </div>

          {/* Tabela de desconectados */}
          {faixaSelecionada && (
            <div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                <span style={{ fontSize: '13px', fontWeight: '600', color: faixaInfo?.cor }}>
                  {desconectadosFaixa.length} veículo{desconectadosFaixa.length !== 1 ? 's' : ''} offline {faixaInfo?.label}
                </span>
                <button onClick={() => exportarPDF(`Veículos Offline ${faixaInfo?.label}`, desconectadosFaixa)}
                  style={{ background: '#E6F1FB', color: '#185FA5', border: 'none', borderRadius: '8px', padding: '7px 14px', cursor: 'pointer', fontSize: '12px', fontWeight: '600' }}>
                  📄 Exportar PDF
                </button>
              </div>
              {desconectadosFaixa.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '24px', color: '#999', fontSize: '13px' }}>
                  ✅ Nenhum veículo offline nessa faixa
                </div>
              ) : (
                <div style={{ overflowX: 'auto' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
                    <thead>
                      <tr style={{ background: '#f8f8f8' }}>
                        {['', 'Placa', 'Nome', 'Cliente', 'Telefone', 'Modelo', 'Chip', 'Última atualização', 'Tempo offline'].map(h => (
                          <th key={h} style={{ padding: '10px 12px', textAlign: 'left', color: '#666', fontWeight: '600', borderBottom: '1px solid #eee', whiteSpace: 'nowrap' }}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {desconectadosFaixa.map((v, i) => (
                        <tr key={i} style={{ borderBottom: '1px solid #f5f5f5' }}
                          onMouseEnter={e => e.currentTarget.style.background = '#fafafa'}
                          onMouseLeave={e => e.currentTarget.style.background = 'white'}>
                          <td style={{ padding: '10px 12px', fontSize: '18px' }}>{v.icone || '🚗'}</td>
                          <td style={{ padding: '10px 12px', fontWeight: '700', fontFamily: 'monospace' }}>{v.identificador}</td>
                          <td style={{ padding: '10px 12px', color: '#333' }}>{v.nome || '—'}</td>
                          <td style={{ padding: '10px 12px', color: '#1D9E75', fontWeight: '500' }}>{v.cliente_nome || '—'}</td>
                          <td style={{ padding: '10px 12px', color: '#666' }}>{v.cliente_celular || v.cliente_telefone || '—'}</td>
                          <td style={{ padding: '10px 12px', color: '#666' }}>{v.equipamento_modelo || '—'}</td>
                          <td style={{ padding: '10px 12px', color: '#666', fontFamily: 'monospace' }}>{v.numero_chip || '—'}</td>
                          <td style={{ padding: '10px 12px', color: '#999' }}>
                            {v.ultima_atualizacao ? new Date(v.ultima_atualizacao).toLocaleString('pt-BR') : 'Nunca conectou'}
                          </td>
                          <td style={{ padding: '10px 12px' }}>
                            <span style={{ background: faixaInfo?.bg, color: faixaInfo?.cor, padding: '3px 8px', borderRadius: '10px', fontWeight: '600', whiteSpace: 'nowrap' }}>
                              {formatarTempo(v.horas_sem_sinal)}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}
        </div>

        {/* LINHA 3 — Veículos mais ativos + Alertas por tipo */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
          <div style={{ background: 'white', borderRadius: '12px', padding: '20px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
            <h3 style={{ margin: '0 0 16px', fontSize: '14px', color: '#333' }}>🏆 Veículos Mais Ativos (7 dias)</h3>
            {dados?.veiculos_mais_ativos?.length === 0 ? (
              <div style={{ textAlign: 'center', color: '#999', padding: '20px', fontSize: '13px' }}>Sem dados suficientes</div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {dados?.veiculos_mais_ativos?.map((v, i) => (
                  <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <span style={{ fontSize: '16px', width: '24px', textAlign: 'center' }}>{v.icone || '🚗'}</span>
                    <div style={{ flex: 1 }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                        <span style={{ fontSize: '12px', fontWeight: '600', color: '#333' }}>{v.identificador}</span>
                        <span style={{ fontSize: '11px', color: '#666' }}>{parseInt(v.total_posicoes)} pts</span>
                      </div>
                      <BarraHorizontal valor={parseInt(v.total_posicoes)} maximo={maxVeiculo} cor={i === 0 ? '#F59E0B' : i === 1 ? '#9CA3AF' : i === 2 ? '#CD7C2F' : '#1D9E75'} />
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div style={{ background: 'white', borderRadius: '12px', padding: '20px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
            <h3 style={{ margin: '0 0 16px', fontSize: '14px', color: '#333' }}>🔔 Alertas por Tipo (30 dias)</h3>
            {dados?.alertas_por_tipo?.length === 0 ? (
              <div style={{ textAlign: 'center', color: '#999', padding: '20px', fontSize: '13px' }}>Nenhum alerta registrado</div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {dados?.alertas_por_tipo?.map((a, i) => {
                  const tipo = tiposAlerta[a.tipo] || { label: a.tipo, cor: '#666' };
                  return (
                    <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <span style={{ fontSize: '12px', width: '160px', color: '#555' }}>{tipo.label}</span>
                      <BarraHorizontal valor={parseInt(a.total)} maximo={maxAlerta} cor={tipo.cor} />
                      <span style={{ fontSize: '12px', fontWeight: '700', color: tipo.cor, width: '30px', textAlign: 'right' }}>{a.total}</span>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>

        {/* LINHA 4 — Últimos acessos de clientes + Posições por dia */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>

          <div style={{ background: 'white', borderRadius: '12px', padding: '20px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
            <h3 style={{ margin: '0 0 16px', fontSize: '14px', color: '#333' }}>👤 Últimos Acessos de Clientes</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {[
                { label: 'Acessaram hoje', dados: acessosHoje, cor: '#1D9E75', bg: '#E1F5EE' },
                { label: 'Acessaram ontem', dados: acessosOntem, cor: '#378ADD', bg: '#E6F1FB' },
                { label: 'Acessaram esta semana', dados: acessosSemana, cor: '#F59E0B', bg: '#FAEEDA' },
                { label: 'Nunca acessaram', dados: semAcesso, cor: '#E24B4A', bg: '#FCEBEB' },
              ].map((grupo, i) => (
                <div key={i} style={{ background: grupo.bg, borderRadius: '8px', padding: '12px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: grupo.dados.length > 0 ? '8px' : '0' }}>
                    <span style={{ fontSize: '12px', fontWeight: '600', color: grupo.cor }}>{grupo.label}</span>
                    <span style={{ fontSize: '16px', fontWeight: '700', color: grupo.cor }}>{grupo.dados.length}</span>
                  </div>
                  {grupo.dados.length > 0 && (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                      {grupo.dados.slice(0, 3).map((u, j) => (
                        <div key={j} style={{ fontSize: '11px', color: '#555', display: 'flex', justifyContent: 'space-between' }}>
                          <span>{u.nome} {u.cliente_nome ? `— ${u.cliente_nome}` : ''}</span>
                          <span style={{ color: '#999' }}>{u.ultimo_acesso ? new Date(u.ultimo_acesso).toLocaleString('pt-BR') : '—'}</span>
                        </div>
                      ))}
                      {grupo.dados.length > 3 && (
                        <div style={{ fontSize: '11px', color: grupo.cor, fontWeight: '500' }}>
                          + {grupo.dados.length - 3} mais...
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          <div style={{ background: 'white', borderRadius: '12px', padding: '20px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
            <h3 style={{ margin: '0 0 16px', fontSize: '14px', color: '#333' }}>📅 Posições por Dia (últimos 30 dias)</h3>
            {dados?.posicoes_por_dia?.length === 0 ? (
              <div style={{ textAlign: 'center', color: '#999', padding: '20px', fontSize: '13px' }}>Sem dados</div>
            ) : (
              <div style={{ display: 'flex', alignItems: 'flex-end', gap: '4px', height: '180px' }}>
                {dados?.posicoes_por_dia?.map((p, i) => {
                  const altura = maxDia > 0 ? (parseInt(p.total) / maxDia) * 100 : 0;
                  return (
                    <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
                      <span style={{ fontSize: '9px', color: '#999' }}>{parseInt(p.total) > 0 ? p.total : ''}</span>
                      <div style={{ width: '100%', background: '#1D9E75', borderRadius: '3px 3px 0 0', height: `${altura}%`, minHeight: altura > 0 ? '4px' : '0', transition: 'height .3s', opacity: 0.8 }} />
                      <span style={{ fontSize: '8px', color: '#999', transform: 'rotate(-45deg)', transformOrigin: 'top left', whiteSpace: 'nowrap' }}>
                        {new Date(p.dia).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' })}
                      </span>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>

        {/* LINHA 5 — Inventário de modelos e operadoras */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>

          <div style={{ background: 'white', borderRadius: '12px', padding: '20px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
            <h3 style={{ margin: '0 0 16px', fontSize: '14px', color: '#333' }}>📟 Inventário por Modelo de Equipamento</h3>
            {!dados?.inventario_modelos?.length ? (
              <div style={{ textAlign: 'center', color: '#999', padding: '20px', fontSize: '13px' }}>Sem dados</div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {dados.inventario_modelos.map((m, i) => (
                  <div key={i} onClick={() => setModalInventario({ tipo: 'modelo', item: m })}
                    style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '10px 14px', background: '#f8f8f8', borderRadius: '8px', cursor: 'pointer', transition: 'background .15s' }}
                    onMouseEnter={e => e.currentTarget.style.background = '#E1F5EE'}
                    onMouseLeave={e => e.currentTarget.style.background = '#f8f8f8'}>
                    <span style={{ fontSize: '20px' }}>📟</span>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '13px', fontWeight: '600', color: '#333' }}>{m.modelo}</div>
                      <div style={{ fontSize: '11px', color: '#999' }}>Clique para ver clientes</div>
                    </div>
                    <span style={{ fontSize: '20px', fontWeight: '700', color: '#1D9E75' }}>{m.total}</span>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div style={{ background: 'white', borderRadius: '12px', padding: '20px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
            <h3 style={{ margin: '0 0 16px', fontSize: '14px', color: '#333' }}>📶 Inventário por Operadora de Chip</h3>
            {!dados?.inventario_operadoras?.length ? (
              <div style={{ textAlign: 'center', color: '#999', padding: '20px', fontSize: '13px' }}>Sem dados</div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {dados.inventario_operadoras.map((o, i) => {
                  const cores = ['#E24B4A', '#1D9E75', '#378ADD', '#7C3AED', '#F59E0B', '#666'];
                  const cor = cores[i % cores.length];
                  return (
                    <div key={i} onClick={() => setModalInventario({ tipo: 'operadora', item: o })}
                      style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '10px 14px', background: '#f8f8f8', borderRadius: '8px', cursor: 'pointer', transition: 'background .15s' }}
                      onMouseEnter={e => e.currentTarget.style.background = '#E6F1FB'}
                      onMouseLeave={e => e.currentTarget.style.background = '#f8f8f8'}>
                      <span style={{ fontSize: '20px' }}>📶</span>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: '13px', fontWeight: '600', color: '#333' }}>{o.operadora}</div>
                        <div style={{ fontSize: '11px', color: '#999' }}>Clique para ver clientes</div>
                      </div>
                      <span style={{ fontSize: '20px', fontWeight: '700', color: cor }}>{o.total}</span>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Modal inventário */}
      {modalInventario && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
          <div style={{ background: 'white', borderRadius: '16px', width: '500px', maxWidth: '100%', maxHeight: '80vh', overflowY: 'auto', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
            <div style={{ padding: '20px 24px', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, background: 'white' }}>
              <div>
                <h2 style={{ margin: 0, fontSize: '16px' }}>
                  {modalInventario.tipo === 'modelo' ? '📟' : '📶'} {modalInventario.tipo === 'modelo' ? modalInventario.item.modelo : modalInventario.item.operadora}
                </h2>
                <div style={{ fontSize: '12px', color: '#999', marginTop: '2px' }}>{modalInventario.item.total} equipamento{modalInventario.item.total > 1 ? 's' : ''}</div>
              </div>
              <button onClick={() => setModalInventario(null)} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#999' }}>×</button>
            </div>
            <div style={{ padding: '16px 24px' }}>
              <div style={{ fontSize: '12px', color: '#666', fontWeight: '600', marginBottom: '12px' }}>CLIENTES COM ESTE {modalInventario.tipo === 'modelo' ? 'MODELO' : 'CHIP'}:</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {(modalInventario.item.clientes || []).filter(Boolean).map((c, i) => (
                  <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 14px', background: '#f8f8f8', borderRadius: '8px' }}>
                    <span style={{ fontSize: '16px' }}>👤</span>
                    <span style={{ fontSize: '13px', color: '#333', fontWeight: '500' }}>{c}</span>
                  </div>
                ))}
                {(modalInventario.item.clientes || []).filter(Boolean).length === 0 && (
                  <div style={{ textAlign: 'center', color: '#999', padding: '20px', fontSize: '13px' }}>Nenhum cliente vinculado</div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Estatisticas;